// Keep the first prototype available for comparison and rollback diagnostics.
const legacy=new URLSearchParams(location.search).get('legacy')==='1';
if(legacy){document.querySelector('link[rel="stylesheet"]').href='/assets/legacy.css';await import('./main.js');}
else await import('./mission/main.js');
